import React, { useState } from 'react';
import { IconButton, InputAdornment, TextFieldProps, FormHelperText } from '@material-ui/core';
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
} from '@material-ui/icons';

import TextField from '../TextField/TextField';

type PinFieldProps = TextFieldProps & {
  showPasswordValidationHint?: boolean;
  disableRules?: boolean;
};

const PinField = ({
  autoComplete,
  name,
  onChange,
  value,
  error,
  helperText,
  showPasswordValidationHint,
  InputProps,
  disableRules,
  ...otherProps
}: PinFieldProps): JSX.Element => {
  const [showPin, setShowPin] = useState<boolean>(false);

  const handleClickShowPin = () => {
    setShowPin(!showPin);
  };

  const handleMouseDownPin = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <>
      <TextField
        {...otherProps}
        type={showPin ? 'text' : 'password'}
        onChange={onChange}
        value={value}
        error={error}
        inputProps={{
          autoComplete,
        }}
        data-tip
        data-for={value}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        InputProps={{
          ...InputProps,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle pin visibility"
                onClick={handleClickShowPin}
                onMouseDown={handleMouseDownPin}
                edge="end"
              >
                {showPin ? (
                  <VisibilityIcon fontSize="small" />
                ) : (
                  <VisibilityOffIcon fontSize="small" />
                )}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {error && helperText && <FormHelperText error>{helperText}</FormHelperText>}
    </>
  );
};

export default PinField;
